import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useGlobalSearch } from '../../hooks/useGlobalSearch';

interface SearchBarProps {
    className?: string;
    placeholder?: string;
    isMobile?: boolean;
}

const SearchBar: React.FC<SearchBarProps> = ({
    className = '',
    placeholder = 'Rechercher un produit...',
    isMobile = false
}) => {
    const { searchTerm, setSearchTerm, handleSearch, clearSearch } = useGlobalSearch();
    const [localSearchTerm, setLocalSearchTerm] = useState('');
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const inputRef = useRef<HTMLInputElement>(null);

    // Sync with URL search params when on catalog page
    useEffect(() => {
        if (location.pathname === '/catalog') {
            const urlSearchTerm = searchParams.get('search') || '';
            setLocalSearchTerm(urlSearchTerm);
            setSearchTerm(urlSearchTerm);
        } else {
            setLocalSearchTerm('');
            setSearchTerm('');
        }
    }, [location, searchParams, setSearchTerm]);

    const onSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        handleSearch(localSearchTerm);
    };

    const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLocalSearchTerm(e.target.value);
    };

    const onClear = () => {
        setLocalSearchTerm('');
        clearSearch();
        inputRef.current?.focus();
    };

    return (
        <form onSubmit={onSubmit} className={`search-bar ${className}`}>
            <div className="search-input-container">
                <input
                    ref={inputRef}
                    type="text"
                    placeholder={placeholder}
                    value={localSearchTerm}
                    onChange={onInputChange}
                    className="search-input"
                />
                {localSearchTerm && (
                    <button
                        type="button"
                        onClick={onClear}
                        className="search-clear-button"
                        aria-label="Effacer la recherche"
                    >
                        ✕
                    </button>
                )}
                <button
                    type="submit"
                    className="search-submit-button"
                    disabled={!localSearchTerm.trim()}
                    aria-label="Rechercher"
                >
                    🔍
                </button>
            </div>
        </form>
    );
};

export default SearchBar;
